/**
 * Donation API
 * Handles API calls for donation operations
 */

import apiClient from "@/lib/api-client"

export interface CreateDonationResponse {
  success: boolean
  data: {
    checkoutUrl: string
    donationId: string
    amount: number
    currency: string
  }
  message: string
}

export interface GetDonationsResponse {
  success: boolean
  data: {
    donations: Donation[]
    totalAmount: number
    totalCount: number
  }
  message: string
}

export interface GetUserDonationsResponse {
  success: boolean
  data: {
    donations: Donation[]
  }
  message: string
}

export interface Donation {
  id: string
  ritualId: string
  donorId: string | null
  amount: number
  currency: string
  status: "PENDING" | "COMPLETED" | "FAILED" | "REFUNDED"
  transactionId: string | null
  createdAt: string
  ritual?: {
    id: string
    title: string
  }
  donor?: {
    id: string
    firstName: string
    lastName: string
    avatar: string | null
  }
}

export const createDonation = async (
  ritualId: string,
  amount: number,
  successUrl: string,
  cancelUrl: string,
  join?: boolean,
): Promise<CreateDonationResponse> => {
  const response = await apiClient.post<CreateDonationResponse>(
    `/api/donations/rituals/${ritualId}/donate`,
    { amount, successUrl, cancelUrl, join },
  )
  return response.data
}

export const getUserDonations = async (): Promise<GetUserDonationsResponse> => {
  const response = await apiClient.get<GetUserDonationsResponse>(
    "/api/donations/users/me/donations",
  )
  return response.data
}

export const getRitualDonations = async (ritualId: string): Promise<GetDonationsResponse> => {
  const response = await apiClient.get<GetDonationsResponse>(
    `/api/donations/rituals/${ritualId}/donations`,
  )
  return response.data
}

export default {
  createDonation,
  getUserDonations,
  getRitualDonations,
}
